import { render, staticRenderFns } from "./SecondaryBtn.vue?vue&type=template&id=56b04bec&"
import script from "./SecondaryBtn.vue?vue&type=script&lang=js&"
export * from "./SecondaryBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports